const tailwindConfig = require('../../../../tailwind.config.js');
const { theme } = tailwindConfig;

export const mqTy = window.matchMedia(`(min-width: ${theme.screens.ty})`)
export const mqXs = window.matchMedia(`(min-width: ${theme.screens.xs})`)
export const mqSm = window.matchMedia(`(min-width: ${theme.screens.sm})`)
export const mqMd = window.matchMedia(`(min-width: ${theme.screens.md})`)
export const mqLg = window.matchMedia(`(min-width: ${theme.screens.lg})`)
